import React, { Component } from "react";
import { Button, FormGroup, Row, Col, Input,Popover, PopoverHeader, PopoverBody} from "reactstrap";
import { analyticsCategories } from '../../../utils/categories';
import {chartStep, kpisMapping, emptyKPIRecords} from '../../../utils/constants';
import {deepClone} from '../../../utils/copyObject';
import {getAgreegateKpisData, getBenchmarkData, filterBenchmarkByState} from '../../../utils/filterKpisData';
import DatePicker from "react-datepicker";
import Toggle from "react-toggle";
import moment from "moment";
import ChartPreview from '../Components/ChartPreview/ChartPreview';
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon';
import "../Chart.css";

class EditOthersChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name : {
        value: this.props.chartDetails.name,
        error: false 
      },
      kpiData: this.props.chartDetails.kpiData || [],
      kpiType: this.props.chartDetails.kpiType,
      kpiRecords: this.props.chartDetails.kpiRecords && this.props.chartDetails.kpiRecords.length>0 ? this.props.chartDetails.kpiRecords : deepClone(emptyKPIRecords),
      startDate: (this.props.chartDetails.startDate!=='' && this.props.chartDetails.startDate!==null) ? moment.utc(this.props.chartDetails.startDate) : null,
      endDate: (this.props.chartDetails.endDate!=='' && this.props.chartDetails.endDate!==null) ? moment(this.props.chartDetails.endDate) : null,
      category: this.props.chartDetails.category,
      useLatestDataAvailable: undefined,
      benchmarkLocation: this.props.chartDetails.benchmarkLocation,
      selectedBenchmarkData: null,
      industriesList: this.props.industriesList || []
    }
  }


  componentWillReceiveProps(nextProps) {
    if(nextProps.chartDetails && nextProps.chartDetails.kpiAgreegateData && nextProps.chartDetails.kpiAgreegateData.length > 0){
      this.setSelectedKpiAgreegateData(nextProps);
    }
  }
  
  componentWillMount() {
    this.setSelectedKpiAgreegateData(this.props);
    // console.log('Will mount');
  }
    
  // // Make create chart request if chart data validated.
  handleEditChart = () => {
    let { startDate, endDate, useLatestDataAvailable, kpiRecords , benchmarkData, benchmarkLocation, selectedBenchmarkData} = this.state;
    const name = this.state.name.value;
    if (!name || name.trim() === "") {
      this.setState({ name: { name: name, error: true } });
      return;
    }
    if (startDate && startDate != "") {
      startDate = startDate.format('YYYY-MM-DD') + 'T00:00:00.000Z';
    } else {
      window.scrollTo(0, 0);
      this.setState({ error: true, errorMessage: 'Please select start date.' });
      return;
    }
    if (useLatestDataAvailable === false) {
      if (endDate && endDate != "") {
        endDate = endDate.format('YYYY-MM-DD') + 'T23:59:59.000Z';
      } else {
        window.scrollTo(0, 0);
        this.setState({ error: true, errorMessage: 'Please select end date.' });
        return;
      }
    }
    this.props.onCompleted({ name, kpiRecords, startDate, endDate, selectedBenchmarkData, benchmarkLocation, useLatestDataAvailable })
  };

    // Set selected kpi agreegate on edit chart
    setSelectedKpiAgreegateData = (props) => {
      let {chartDetails, orgMapping} = props;
      let {gender, occupationOptions, seniorityOptions, performanceOptions, separationOptions} = orgMapping;
      let {kpiAgreegateData, kpiBenchmarkData, benchmarkData, selectedBenchmark, name, kpiData, startDate, endDate, kpiType} = chartDetails;
      let {kpiRecords, selectedBenchmarkData, useLatestDataAvailable} = this.state;
      let benchmarkLocation = {country: null, state: null};
      let {country, state} = this.state.benchmarkLocation;
      if(useLatestDataAvailable === undefined) {
        useLatestDataAvailable = chartDetails.useLatestDataAvailable;
      }
      startDate = (startDate && startDate!==null && startDate!=='') ? moment(startDate) : null;
      endDate = (endDate && endDate!==null && endDate!=='') ? moment(endDate) : null;
      let occupation = null;
      let seniority = null;
      let selectedGender = null;
      let performance = null;
      let separation = null;
      let selectedKpiRecords = kpiRecords.filter(kpi => kpi.selected);
      if(selectedKpiRecords.length == 0 && kpiData && kpiData.length>0 && orgMapping && (gender.length > 0 || occupationOptions.length > 0 || seniorityOptions.length > 0 || performanceOptions.length > 0 || separationOptions.length > 0) ) {
        kpiRecords = kpiRecords.map((kpiRecord, index) => {
          if (kpiData[index]) {
            let { kpiId, occupationId, seniorityId, diversityType } = { ...kpiData[index] };
            let selectedKPI = { id: kpiId._id, name: kpiId.name, code: kpiId.code, description: kpiId.description };
            let filteredGender = kpiRecord.genderOptions.filter(gender => gender.id === diversityType);
            if(filteredGender.length > 0){
              selectedGender = filteredGender[0];
            }
            if (occupationId) {
              let foundOccupation = occupationOptions.filter(occupation => occupationId._id === occupation.id);
              if(foundOccupation.length > 0) {
                occupation = foundOccupation[0];
              }
            }
            if (seniorityId) {
              let foundSeniority= seniorityOptions.filter(seniority => seniorityId._id === seniority.id);
              if(foundSeniority.length > 0) {
                seniority = foundSeniority[0];
              }  
            }
            if(kpisMapping[selectedKPI.code].performance){
              let {performanceOptions} = orgMapping;
              let perfomanceKey = kpisMapping[selectedKPI.code].performanceKey;
              let performanceMapping = performanceOptions ? performanceOptions : [] ;
              let matchedPerfomance = performanceMapping.filter(performance => performance.name === perfomanceKey);
              if(matchedPerfomance.length > 0){
                performance = matchedPerfomance[0];
              }
            }
            if(kpisMapping[selectedKPI.code].separation){
              let {separationOptions} = orgMapping;
              let separationKey = kpisMapping[selectedKPI.code].separationKey;
              let separationMapping = separationOptions ? separationOptions : [] ;
              let matchedSeparation = separationMapping.filter(separation => separation.name === separationKey);
              if(matchedSeparation.length > 0){
                separation = matchedSeparation[0];
              }
            }
            return { ...kpiRecord, 
              gender: selectedGender,
              selectedKPI, occupation, 
              seniority, performance, separation, selected: true, 
              enableGender: kpisMapping[kpiId.code]['gender'] ? kpisMapping[kpiId.code]['gender'] : false,
              enableOccupation: kpisMapping[kpiId.code]['occupation'] ? kpisMapping[kpiId.code]['occupation'] : false,
              enableSeniority: kpisMapping[kpiId.code]['seniority'] ? kpisMapping[kpiId.code]['seniority'] : false, };
          } else {
            return kpiRecord;
          }
        })  
      };
      if(this.state.startDate!==null){
        startDate = this.state.startDate;
      }
      if(this.state.endDate!==null){
        endDate = this.state.endDate;
      }
      if(kpiAgreegateData && kpiAgreegateData.length > 0) {
         let formattedKpiData = getAgreegateKpisData({kpiRecords, kpiAgreegateData, kpiType, startDate, endDate, useLatestDataAvailable});
        if(selectedKpiRecords.length === 1 && kpiBenchmarkData.length>0) {
          if (chartDetails.benchmarkData && chartDetails.benchmarkData.location && kpiBenchmarkData && kpiBenchmarkData.length>0) {
            let { location } = props.chartDetails.benchmarkData;
            benchmarkLocation = { country: { name: 'United States', code: 'US' }, state: { id: location.key, name: location.name } };
            selectedBenchmarkData = filterBenchmarkByState(kpiBenchmarkData,benchmarkLocation.state.name);
            benchmarkData = getBenchmarkData({selectedBenchmark: selectedBenchmarkData, kpiAgreegateData}, true, {startDate, endDate, useLatestDataAvailable});
          } else {
            benchmarkLocation = this.state.benchmarkLocation;
          }
        }
        this.setState({name: {value: name}, kpiRecords, kpiType, kpiData: formattedKpiData, benchmarkData, benchmarkLocation, selectedBenchmarkData, orgMapping, useLatestDataAvailable}); 
      } else {
        this.setState({name: {value: name}, startDate, endDate, kpiRecords, kpiType, kpiData, benchmarkData, orgMapping, useLatestDataAvailable});  
        if (kpiType && startDate !== null) {
          let selectedKPIRecords = kpiRecords.filter(kpi => kpi.selectedKPI !== null);
          this.props.previewChart({selectedKPIRecords,kpiType,startDate,endDate,useLatestDataAvailable});
        }
      }    
    }

  handlePreviewChart = () => {
    let { startDate, endDate, useLatestDataAvailable } = this.state;
    this.previewChart(startDate,endDate,useLatestDataAvailable);
  } 

  previewChart = (startDate, endDate, useLatestDataAvailable) => {
    let { kpiType, kpiRecords } = this.state;
    let selectedKPIRecords = kpiRecords.filter((kpi => kpi.selectedKPI !== null));
    if(startDate!==null) {
      startDate = startDate.format('YYYY-MM-DD') + 'T00:00:00.000Z'; 
    }
    if(endDate!==null) {
      endDate = endDate.format('YYYY-MM-DD') + 'T23:59:59.000Z'; 
    }
    this.props.previewChart({ selectedKPIRecords, kpiType, startDate, endDate, useLatestDataAvailable });
  }

  handleStartDateChange = date => {
    let {endDate, useLatestDataAvailable} = this.state;
    if (this.state.endDate!==null && date > this.state.endDate) {
      this.setState({
        startDate: this.state.endDate
      });
      this.previewChart(endDate,endDate,useLatestDataAvailable);
    } else {
      this.setState({
        startDate: date
      });
      this.previewChart(date,endDate,useLatestDataAvailable);
    }
  };

  handleEndDateChange = date => {
    let {startDate, useLatestDataAvailable} = this.state;
    if (this.state.startDate!=null && date < this.state.startDate) {
      this.setState({
        endDate: this.state.startDate
      });
      this.previewChart(startDate,startDate,useLatestDataAvailable);
    } else {
      this.setState({
        endDate: date
      });
      this.previewChart(startDate,date,useLatestDataAvailable);
    }
  };

  toggleLatestDataAvailablePopover = () => {
    this.setState({ dataAvailablePopoverOpen: !this.state.dataAvailablePopoverOpen });
  }

  handleUseLatestDateChange = () => {
    let {startDate, useLatestDataAvailable} = this.state;
    this.setState({ useLatestDataAvailable: !useLatestDataAvailable, endDate: null, error: false });
    this.previewChart(startDate,null,!useLatestDataAvailable);
  }

  navigateToCategory = () => {
    let link = '';
      for (let category of analyticsCategories) {
        if (category.name === this.props.chartDetails.category) {
          link = category.link;
        }
      }
    this.props.history.push("/home/analytics/"+link);
  };

  // Trigger datepicker on calender icon
  openDatePicker = (id) => { 
    document.getElementById(id).click();
  }

  render() {
    // console.log('Render');
    let { name, kpiData, benchmarkData, useLatestDataAvailable, startDate, endDate, industriesList} = this.state;
    let {privacy, kpiType} = this.props.chartDetails;
    return (
      <div>
      <Row><Col sm={11} md={11}><div className="edit-chart-hr mt10"></div></Col></Row>
      <FormGroup className="mt30" row>
          <Col sm={3} sm={3} lg={3}>
            <div className="float-right chart-name-label">
              Name
            </div>
          </Col>
          <Col sm={8} md={8} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="name-hint-max-length name-char-count-txt">
                {this.state.name.value ? this.state.name.value.length : 0 }/64
              </span>
              <Input
                type="text"
                name="chartTitle"
                className="input-custom"
                value={this.state.name.value}
                id="chartTitle"
                maxLength="64"
                onChange={({target})=> this.setState({name: { value: target.value, error: false }})}
                placeholder="Write a short distinct name for a new chart"
                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                invalid={this.state.name.error}
              />
            </div>
            {(this.state.name.error) ? <div className="input-error-msg-field">Please enter chart name.</div> : null}
          </Col>
        </FormGroup>
        <FormGroup className="mt25" row>
          <Col sm={3} md={3} className="text-right">
            <div className="text-right chartLabel">Start Date</div>
          </Col>
          <Col sm={3} md={3} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker('startDatePicker')} />
              <DatePicker id="startDatePicker" placeholderText="Select start date" className="input-custom-date form-control" selectsStart showYearDropdown selected={startDate} onChange={this.handleStartDateChange} startDate={this.state.startDate} endDate={this.state.endDate} maxDate={moment(new Date())} />
            </div>
          </Col>
        </FormGroup>
        <FormGroup className="mt25" row>
          <Col sm={3} md={3} className="text-right">
            <div className="text-right chartLabel">End Date</div>
          </Col>
          <Col sm={3} md={3} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="tool-end-date">
                <span className="flaticon-calendar" onClick={() => this.openDatePicker('endDatePicker')} />
              </span>
              <DatePicker id="endDatePicker" placeholderText="Select end date" className="input-custom-date form-control" selectsEnd showYearDropdown selected={this.state.endDate} onChange={this.handleEndDateChange} startDate={this.state.startDate} endDate={this.state.endDate} maxDate={moment(new Date())} disabled={useLatestDataAvailable} />
            </div>
          </Col>
          <Col className="d-flex pl0">
            <div className="d-flex align-items-center">
              <span className="or-latest-data">or</span>
              <span className="ml10">
                <Toggle defaultChecked={useLatestDataAvailable} icons={false} onChange={this.handleUseLatestDateChange} />
              </span>
              <span className="ml10 latest-data-available">
                latest data available
              </span>
              <span id="latest-data-available-popover" className="ml10" onClick={this.toggleLatestDataAvailablePopover}>
                <Tooltip />
              </span>
              <Popover placement="right" isOpen={this.state.dataAvailablePopoverOpen} target="latest-data-available-popover" toggle={this.toggleLatestDataAvailablePopover}>
                <PopoverHeader className="popover-header-tooltip">
                  Latest Data Available
                </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  If you select "latest data available" the time series will
                  include all data from your start date to the latest date
                  that data is available for this KPI. NOTE this chart will
                  be updated automatically when new data is available.
                </PopoverBody>
              </Popover>
            </div>
          </Col>
        </FormGroup>
        <FormGroup className="mt40 mb0" row>
          <Col sm={{size: 3, offset: 5}} md={{size: 3, offset: 5}}>
            <Button className="float-right goBackBtn w100" onClick={this.handlePreviewChart}>
              <span className="cancelBtnTxt"><span className="mr10 flaticon-vision" />Preview</span>
            </Button>
          </Col>
          <Col sm={3} md={3} className="col-md-offset-right-1">
            <Button className="float-right continueBtn ml10 w100" onClick={this.handleEditChart}>
              <span className="continueBtnTxt">
                Submit <span className="ml10 flaticon-tick" />
              </span>
            </Button>
          </Col>
        </FormGroup>
        {kpiType !== '' &&
        <Row className="mt40 mb20">
        <Col sm={11} md={11}>
          <ChartPreview 
           name={name.value} privacy={privacy} kpiData={kpiData} benchmarkData={benchmarkData} 
           startDate={startDate} endDate={endDate} useLatestDataAvailable={useLatestDataAvailable}  
           industriesList={industriesList} {...this.props}/>

          {/* // name={name.value} privacy={privacy} kpiData={kpiData} benchmarkData={benchmarkData} startDate={startDate}  */}
          {/* // endDate={endDate} useLatestDataAvailable={useLatestDataAvailable} */}
        </Col>
        </Row>}
    </div>
    );
  }
}

export default EditOthersChart;
